import { customerBusiness } from "api/bussiness/customer/customer-bussiness";
import { customerContactBusiness } from "api/bussiness/customer/customer-contact-bussiness";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { GetCustomer } from "api/models/request/customer/customer";
import {
  ContactInformation,
  IContactInformationProperties,
} from "mobx-stores/_models/customers/contact-information";
import {
  Customer,
  CustomerDetail,
  ICustomerDetailProperties,
  ICustomerProperties,
} from "mobx-stores/_models/customers/customer";
import { Pagination } from "../../api/models/response/pagination";
import { withSetPropAction } from "../_extension/with-set-props";
import { PaginationStore } from "./common/pagination-store";

export const CustomerContactManagement = types
  .model({
    openNew: false,
    openEdit: false,
    openDelete: false,
    selectdContact: types.maybeNull(ContactInformation),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getContactDetail: flow(function* getContactDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield customerContactBusiness.getById(
          id
        )) as IContactInformationProperties;
        self.setProp("selectdContact", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));

export const CustomerManagement = types
  .model({
    customers: types.optional(types.array(Customer), []),
    pagination: types.optional(PaginationStore, {}),
    customerDetail: types.maybeNull(CustomerDetail),
    contactManagement: types.optional(CustomerContactManagement, {}),
    openNew: false,
    openEdit: false,
    openDelete: false,
    showIsDisabled: false,
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getCustomers: flow(function* getCustomers(request: GetCustomer) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield customerBusiness.getLists(
          request
        )) as Pagination<ICustomerProperties>;
        self.setProp(
          "customers",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          }))
        );
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getCustomerDetail: flow(function* getCustomerDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield customerBusiness.getById(
          id
        )) as ICustomerDetailProperties;
        self.setProp("customerDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
